import superagent from 'superagent'
import { RequestControl, RequestCommonResponse } from '../actions'

const actions = {
  // 用户订单列表
  userOrder ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      commit('UPDATE_LOADING', true)
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/order/mine/get_orders_new')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          setTimeout(function () {
            commit('UPDATE_LOADING', false)
          }, 200)
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  },
  getOrderBusLocation ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      // commit('UPDATE_LOADING', true)
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/charter/order/bus_locations')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          // setTimeout(function () {
          //   commit('UPDATE_LOADING', false)
          // }, 200)
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/myOrder.js